import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { CommandCenterReport, CommandCenterReportConfiguration } from "src/app/shared/models/CommandCenterReportConfiguration.item";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { ReportOption } from "src/app/shared/models/enums/ReportOption.enum";
import { UserRoleEnum } from "src/app/shared/models/enums/user-role.enum";

@Component({
	selector: "app-report-setup",
	templateUrl: "./report-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class ReportSetupComponent implements OnInit {
	newCategoryOptionSelected: boolean = false;

	reportAccessRoles: GenericLabelValue[] = [];
	reportCategories: GenericLabelValue[];
	reportConfiguration: CommandCenterReportConfiguration;
	reportItems: any[];
	reportOptions: GenericLabelValue[] = [];

	selectedReportItem: CommandCenterReport;

	constructor(public app: AppService, private focuslink: FocuslinkService, private userService: UserService) {}

	ngOnInit(): void {
		this.reportConfigurationGet();
		this.selectedReportItem = new CommandCenterReport();
		Object.keys(UserRoleEnum).forEach((o) => {
			if (isNaN(+o)) {
				this.reportAccessRoles.push({
					label: o,
					value: UserRoleEnum[o],
					disabled: UserRoleEnum[o] > this.userService.user?.role,
				});
			}
		});

		Object.keys(ReportOption).forEach((o) => {
			this.reportOptions.push({
				label: ReportOption[o],
				value: ReportOption[o],
			});
		});
	}

	onNodeSelect(event) {
		this.selectedReportItem = this.reportConfiguration.reports.find((i) => i.key === event.node.id);
	}

	async reportConfigurationGet() {
		const resp = await this.focuslink.adminCommandCenterReportGet();
		this.reportConfiguration = new CommandCenterReportConfiguration(resp);
		this.toTreeFormat(this.reportConfiguration.reports);
	}

	onDelete() {
		this.focuslink.adminCommandCenterReportDelete(this.selectedReportItem.key);
		this.reportConfiguration.reports.splice(
			this.reportConfiguration.reports.findIndex((i) => i.key === this.selectedReportItem.key),
			1
		);
	}

	onSave() {
		if (this.selectedReportItem.key) {
			this.focuslink.adminCommandCenterReportPatch(this.selectedReportItem).then((data) => {
				this.reportConfiguration = new CommandCenterReportConfiguration(data);
				this.toTreeFormat(this.reportConfiguration.reports);
			});
		} else {
			this.focuslink.adminCommandCenterReportPut(this.selectedReportItem).then((data) => {
				this.reportConfiguration = new CommandCenterReportConfiguration(data);
				this.toTreeFormat(this.reportConfiguration.reports);
			});
		}
	}

	selectCategory(event) {
		if (event.value === "newCategory") {
			this.selectedReportItem.category = "";
			this.newCategoryOptionSelected = true;
		} else {
			this.newCategoryOptionSelected = false;
		}
	}

	toTreeFormat(data: CommandCenterReport[]) {
		this.reportCategories = [
			{
				label: "New Category",
				value: "newCategory",
			},
		];
		this.reportItems = [];
		const categories = Array.from(new Set(data.map((i) => i.category)));

		categories.forEach((cat) => {
			this.reportCategories.push({
				label: cat,
				value: cat,
			});
			this.reportItems.push({
				label: cat,
				children: data
					.filter((itm) => itm.category === cat)
					.sort((a, b) => (a.name > b.name ? 1 : -1))
					.map((itm) => {
						return {
							label: itm.name,
							id: itm.key,
							accessLevel: itm.accessLevel,
							description: itm.description,
							options: itm.options,
							tooltipOptions: itm.optionDisabled,
						};
					}),
			});
		});
		this.reportCategories.sort((a, b) => (a.label > b.label ? 1 : -1));
		this.reportItems.sort((a, b) => (a.label > b.label ? 1 : -1));
	}
}
